import React, { useState, useEffect } from 'react'
import { Breadcrumb, BreadcrumbItem, Row, Col } from 'reactstrap';
import toast, { Toaster } from 'react-hot-toast';

//Componentes
import SendEmailButton from '../../../components/buttons/sendEmailButton';
import LoadingTransparent from '../../../components/modales/loadingModalTransparent';
import ModalEnvioProrrogas from '../componentes/modalEnvioProrrogas';
import ModalGeneracionProrroga from '../componentes/modalGeneracionProrroga';
import IconCard from '../../../components/cards/iconCard';

//Utils
import { userRolValidation} from '../../../utils/userValidation/rolValidation'

//Redux
import { connect } from 'react-redux';

//Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

//API Calls
const { apiInformeProrrogas, apiInformeProrrogasGeneral, apiGenerarProrroga } = require('../../../utils/APIs/APISResume')

//Info usuario en Reducer
const mapStateToProps = state => ({
    usuarioActivo: state
})
const rolesHabilidatos = ['administrador', 'contratador']

let GestionContratos = (props) => {
    const [modalEnvioProrrogas, setModalEnvioProrrogas] = useState(false);
    const [modalGeneracionProrrogas, setModalGeneracionProrrogas] = useState(false);
    const [modalTransaction, setModalTransaction] = useState(false);
    
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    useEffect(() => {
        document.title = "Consulta de Prorrogas";
    })
    const downloadProrrogas = async (body) => {
        let validation = userRolValidation(rolesHabilidatos, userData)
        if (validation) {
            setModalTransaction(true)
            try {
                const bodyReq = {
                    type: "EXCEL",
                    id:userData.userId,
                    gerencia: body.gerencia ?? userData.gerencia,
                    start: body.start,
                    end: body.end,
                    cod_empr: userData.codigoEmpresa
                }
                let request
                if (body.gerencia === 0) {
                    request = await apiInformeProrrogasGeneral(bodyReq);
                }
                else {
                    request = await apiInformeProrrogas(bodyReq);
                }
                let downloadWindow = window.open(request.link, "_blank", "noopener,noreferrer")
                if (downloadWindow) downloadWindow.opener = null
                toastSuccess('Descarga Exitosa!')
                setModalTransaction(false)
            }
            catch (e) {
                toastError('Error con la descarga de prorrogas')
            }
        }
        else {
            toastError('No tienes permisos para realizar esta acción')
        }
    }

    const downloadDocProrroga = async (body) => {
        let validation = userRolValidation(rolesHabilidatos, userData)
        if (validation) {
            setModalTransaction(true)
            try {
                const bodyReq = {
                    cod_empl: body.codEmpl,
                    cod_empr: userData.codigoEmpresa,
                    contratoId: body.tipo
                }
                const request = await apiGenerarProrroga(bodyReq);
                let downloadWindow = window.open(request, "_blank", "noopener,noreferrer")
                if (downloadWindow) downloadWindow.opener = null
                toastSuccess('Descarga Exitosa!')
                setModalTransaction(false)
            }
            catch (e) {
                toastError('Error con la descarga de prorrogas')
            }
        }
        else {
            toastError('No tienes permisos para realizar esta acción')
        }
    }

    const renderModalEnvioProrrogas = () => {
        return (
            <ModalEnvioProrrogas
                toggle={() => { toggleEnvioProrrogas() }}
                modal={modalEnvioProrrogas}
                userData={userData}
                action={(e) => downloadProrrogas(e)}
            />
        )
    }
    const renderModalGeneracionProrrogas = () => {
        return (
            <ModalGeneracionProrroga
                toggle={() => { toggleGeneracionProrrogas() }}
                modal={modalGeneracionProrrogas}
                action={(e) => downloadDocProrroga(e)}
            />
        )
    }

    const toggleEnvioProrrogas = () => setModalEnvioProrrogas(!modalEnvioProrrogas);
    const toggleGeneracionProrrogas = () => setModalGeneracionProrrogas(!modalGeneracionProrrogas);

    return (
        <div>
            {renderModalEnvioProrrogas()}
            {renderModalGeneracionProrrogas()}
            <Toaster />
            <LoadingTransparent isOpen={modalTransaction} />
            {/* <Breadcrumb>
                <BreadcrumbItem className='breadcum-display-content' active>
                    Prorrogas
                    <SendEmailButton onClick={() => toggleEnvioProrrogas()} />
                </BreadcrumbItem>
            </Breadcrumb> */}
            <div className='user-management-page'>
                <Row>
                    <Col lg='3' md='6' xs="12">
                        <IconCard
                            icon={'AiOutlineClockCircle'}
                            subText={'Vencimiento de contratos'}
                            onClick={() => {
                                toggleEnvioProrrogas()
                            }} />
                    </Col>
                    <Col lg='3' md='6' xs="12">
                        <IconCard
                            icon={'AiOutlineFileText'}
                            subText={'Generar Prorroga'}
                            onClick={() => {
                                toggleGeneracionProrrogas()
                            }} />
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default connect(mapStateToProps)(GestionContratos);